import { useCallback, useEffect, useState } from "react";
import { INiche } from "@/common/services/types";
import { apiNiches } from "../services";
import { isAuthenticated } from "../services/Auth";
import { useFetch } from "./useFetch";

export const useFollowingNiche = () => {
  const [following, setFollowing] = useState<string[]>([]);

  const fetchFollowingNiches = useCallback(() => apiNiches.getFollowingNiches({ previews: false }), []);
  const { execute, data } = useFetch(fetchFollowingNiches, false);

  useEffect(() => {
    (async () => {
      try {
        if (await isAuthenticated()) {
          execute();
        }
      } catch (err) {
        console.error("Error checking authentication:", err);
      }
    })();
  }, []);

  useEffect(() => {
    if (data) {
      const followIds = data.niches.map((niche: INiche): string => niche.id);
      setFollowing(followIds);
    }
  }, [data]);

  const isFollowing = useCallback((id: string): boolean => {
    return following.indexOf(id) >= 0;
  }, [following]);

  const addFollowing = useCallback((id: string): void => {
    setFollowing((prev) => [...prev, id]);
  }, []);

  const removeFollowing = useCallback((id: string): void => {
    setFollowing((prev) => {
      return prev.filter((x) => x !== id);
    });
  }, []);

  const onFollow = useCallback((id: string, status: boolean): void => {
    if (status) {
      addFollowing(id);
    } else {
      removeFollowing(id);
    }
  }, [addFollowing, removeFollowing]);

  return {
    onFollow,
    isFollowing,
    following
  };
};
